export const DIFFERENT_DEGREE = 'Enter a different degree';
export const HS_DIPLOMA = 'High School';
export const GED = 'GED';
export const SOME_COLLEGE_NO_DEGREE = 'Some college (No degree)';

export const HIGH_SCHOOL_DEGREES = [GED, HS_DIPLOMA];
export const COLLEGE_DEGREES = [
  SOME_COLLEGE_NO_DEGREE,
  'Associate of Arts',
  'Associate of Applied Science',
  'Associate of Science',
  'Bachelor of Arts',
  'Bachelor of Science',
];
export const MASTER_DEGREES = ['Master of Arts', 'Master of Science', 'MBA', 'J.D.'];

const degrees = [
  ...HIGH_SCHOOL_DEGREES,
  ...COLLEGE_DEGREES,
  'BBA',
  ...MASTER_DEGREES,
  'M.D.',
  'Ph.D',
  DIFFERENT_DEGREE,
];

export default degrees;
